import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Engine() {
	return (
		<div>
			<NeonHero
				title="Engine Services"
				subtitle="Expert diagnostics, repair and rebuilds. AI routes complex jobs to our hubs and automates parts procurement for speed and quality."
				primaryCta={{ label: 'Book Now', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">What we cover</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Check engine diagnostics and root-cause isolation</li>
					<li>Gaskets, timing, heads, and short/long block replacements</li>
					<li>Fuel, ignition, intake and exhaust systems</li>
					<li>Preventative maintenance and performance upgrades</li>
				</ul>

				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Digital intake and remote diagnostics</li>
							<li>AI parts sourcing and estimate approval</li>
							<li>Hub scheduling and repair execution</li>
							<li>QA, road test and documentation</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Drive Now, Pay Later with Affirm or Klarna — 0% for 12 months with approved credit. Apply at checkout.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Most component repairs: 1–3 days. Rebuilds: 3–7 days depending on parts availability.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
